import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { UserInfoType } from '../organization/users/getUserInfoApi';

export const getUserDetailsByProxyApi = async (userId: string): Promise<ApiResponseType<UserInfoType>> => {
  const uri = `/recipient/users/${userId}/`;

  return authApiService.GET(uri);
};
